import BarChart from './BarChart';
import BarChartVertical from './BarChartVertical';
import GaugeChart from './GaugeChart';

export const UPSChart = ({ dashboard }) => {
  const data = dashboard.reduce(
    (acc, item) => {
      // eslint-disable-next-line no-unused-vars
      const [_, label, value] = item;
      if (label.includes('% tải')) {
        acc.dsi = value;
      } else if (label.includes('Runtime')) {
        acc.runtime = value;
      } else if (label.includes('Phase')) {
        acc.volts.push(item);
      }
      return acc;
    },
    {
      dsi: 0,
      runtime: 0,
      volts: [],
    }
  );
  return (
    <div
      style={{
        display: 'flex',
        gap: '70px',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      className="ups-chart"
    >
      <BarChartVertical
        label="DSI"
        value={data.dsi}
        percentage="25"
        color="#37a2da"
        unit="%"
      />
      <GaugeChart value={data.runtime} />
      <BarChart data={data.volts} />
    </div>
  );
};
